import { BASE_URL } from '../config/environment';

export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('data:')) {
    return imagePath;
  }
  
  // Clean path
  let cleanPath = imagePath.trim();
  if (!cleanPath.startsWith('/')) {
    cleanPath = `/${cleanPath}`;
  }
  
  return `${BASE_URL}${cleanPath}`;
};

export const hideBrokenImage = (event) => {
  const image = event.currentTarget;
  image.onerror = null;
  image.src = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="450" viewBox="0 0 800 450">
      <defs>
        <linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#1e40af" />
          <stop offset="50%" stop-color="#2563eb" />
          <stop offset="100%" stop-color="#3b82f6" />
        </linearGradient>
        <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(255,255,255,0.08)" stroke-width="1"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#g)" />
      <rect width="100%" height="100%" fill="url(#grid)" />
      <circle cx="400" cy="180" r="48" fill="rgba(255,255,255,0.15)"/>
      <path d="M380 195 L395 165 L410 185 L420 175 L430 195 Z" fill="#ffffff" opacity="0.9"/>
      <circle cx="388" cy="165" r="4" fill="#ffffff"/>
      <text x="50%" y="270" dominant-baseline="middle" text-anchor="middle" fill="#ffffff" font-family="system-ui, -apple-system, sans-serif" font-weight="bold" font-size="26" letter-spacing="1">FBRSTAPP</text>
      <text x="50%" y="305" dominant-baseline="middle" text-anchor="middle" fill="rgba(255,255,255,0.8)" font-family="system-ui, -apple-system, sans-serif" font-size="16">FBR Digital Invoicing &amp; Compliance</text>
    </svg>`
  );
};

